/**
 * Promotion candidates: tier-3 to tier-2 event-type promotion review (superadmin only).
 * The list itself is shared with the Observability page.
 */
import { useState } from 'react';
import { Toolbar } from '../../components/ui/index.js';
import { FilterPills } from '../../components/ui/index.js';
import { ListPage } from '../../components/page/ListPage.js';
import { PAGE_HELP } from '../../help/index.js';
import { PromotionCandidatesList } from './PromotionCandidatesList.js';

const SCOPE_PILLS = [
  { id: 'pending', label: 'Pending review' },
  { id: 'all', label: 'All' },
];

export function PromotionCandidatesPage() {
  const [scope, setScope] = useState('pending');

  return (
    <ListPage
      title="Promotion candidates"
      subtitle="Event types used across projects that could move into a shared module."
      helpContent={PAGE_HELP['promotion-candidates']}
      toolbar={
        <Toolbar pills={<FilterPills aria-label="Show" options={SCOPE_PILLS} value={scope} onChange={setScope} />} />
      }
    >
      <PromotionCandidatesList showAll={scope === 'all'} />
    </ListPage>
  );
}
